export default {
    /**
     * Datos añadidos a data por el mixin:
     * - streetTypesOptions: array con tipos de vias
     *
     * @return {Object} Data del mixin
     */
    data() {
        return {
            streetTypesOptions: []
        };
    },
    methods: {
        /**
         * Load street types
         */
        loadStreetTypesOptions() {
            const streetTypes = this.$t(`streetTypes`);
            this.streetTypesOptions = Object.entries(streetTypes).map(item => {
                return {
                    key: item[0],
                    name: item[1]
                };
            });
        }
    },

    /**
     * Antes de montar el componente se cargan los tipos de vías en la variable
     * `this.streetTypesOptions`
     */
    beforeMount() {
        this.loadStreetTypesOptions();
    }
};
